import { publicClient } from "../../../public_directory";
import type { PublicCancellation } from "../../domain/types";

/**
 * Cancelling an appointment from the link in its email, with no account.
 *
 * The token is the authorisation, so it never goes in a path: paths end up in
 * proxy and server logs and in telemetry, bodies do not. The client is the
 * anonymous one — a therapist signed in on the same browser must not send
 * their credentials to an endpoint that neither needs nor checks them.
 *
 * A 404 means it is not a link we issued (or it expired); a 409 on cancel
 * carries the reason it was refused in `detail`.
 */
export const PublicAppointmentsAPI = {
    lookup: (token: string) =>
        publicClient.post<PublicCancellation>("/public/appointments/cancel/lookup", { token }),

    cancel: (token: string) =>
        publicClient.post<PublicCancellation>("/public/appointments/cancel", { token }),
};
